"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsoluteDateFilterForm = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var conversions_1 = require("./conversions");
var DateRangePicker_1 = require("../DateRangePicker/DateRangePicker");
var dayPickerProps = {
    firstDayOfWeek: 0,
};
var AbsoluteDateFilterForm = /** @class */ (function (_super) {
    tslib_1.__extends(AbsoluteDateFilterForm, _super);
    function AbsoluteDateFilterForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRangeChange = function (range) {
            _this.props.onSelectedFilterOptionChange(conversions_1.dateRangeToDateFilterValue(range, _this.props.selectedFilterOption.localIdentifier));
        };
        return _this;
    }
    AbsoluteDateFilterForm.prototype.render = function () {
        var _a = this.props, dateFormat = _a.dateFormat, isMobile = _a.isMobile, selectedFilterOption = _a.selectedFilterOption, errors = _a.errors;
        return (react_1.default.createElement(DateRangePicker_1.DateRangePicker, { dateFormat: dateFormat, onRangeChange: this.handleRangeChange, range: conversions_1.dateFilterValueToDateRange(selectedFilterOption), errors: errors, isMobile: isMobile, dayPickerProps: dayPickerProps }));
    };
    return AbsoluteDateFilterForm;
}(react_1.default.Component));
exports.AbsoluteDateFilterForm = AbsoluteDateFilterForm;
//# sourceMappingURL=AbsoluteDateFilterForm.js.map